var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-dashboard-card',{attrs:{"title":"온실가스 배출량"}},[_c('apex-chart',{staticClass:"my-3",attrs:{"type":"donut","width":"450","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }